import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../AppContext';
import { Link } from 'react-router-dom';

const Finish: React.FC = () => {
  const navigate = useNavigate();
  const context = useContext(AppContext);

  if (!context) {
    throw new Error('Finish must be used within an AppProvider');
  }

  const { appData } = context;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleFinish = async () => {
    setLoading(true);
    setError(null);

    const projectId = appData.id; // Substituir pelo ID real
  
    try {
      const colors = localStorage.getItem("customColors");
      
      const response = await fetch(`https://project.zas.media/api/projects/${projectId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer a6ee1bd7ccbfef1a8db07e17301f655d97fb2e6afef919ee948255bda46e119f6047f21dae468735686d475f34a57749accdaf90bc15adca708605fa98957b23a65c62db8570d6bcf36cc67355c35b7d1abafefa286b49cf899f7c30b93a27808742aea88aa3f701f3e8ced623b28924849d5206a9a3b20331f5906e8ed68638`, // Se precisar de autenticação
        },
        body: JSON.stringify({
          data: {
            type: appData.type,
            title: appData.title,
            icon: null, // Será atualizado após o upload
            store_title: appData.storeTitle,
            short_description: appData.shortDescription,
            description: appData.description,
            logo: null, // Será atualizado após o upload
            logo_appbar: null,
            logo_radio: null,
            colors: colors ? JSON.parse(colors) : {},
            home: appData.homeItems,
            nav: appData.navItems,
            more: appData.moreItems,
            locale: "pt-BR",
          },
        }),
      });
  
      if (!response.ok) {
        throw new Error("Erro ao enviar os dados. Tente novamente.");
      }
  
      const result = await response.json();
      console.log("Registro atualizado:", result);
  
      // Se houver imagens para enviar, chama o upload
      if (appData.icon || appData.logo || appData.appBarLogo || appData.radioLogo) {
        await uploadImages(result.data.id, projectId!);
      } else {
        console.log('Sucesso');
        // navigate("/sucesso");
      }


    } catch (err) {
      // setError(err.message);
    } finally {
      setLoading(false);

      navigate(`/${appData.id}/concluido`);
    }
  };

  const dataURLtoFile = (dataUrl: string, filename: string) => {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)?.[1] || "image/png";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
  
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
  
    return new File([u8arr], filename, { type: mime });
  };
  
  const uploadImages = async (appId: string, projectId: string) => {
    console.log("📤 Atualizando imagens para o projeto:", appId);
  
    try {
      const uploadPromises: Promise<{ field: string; id: number }>[] = [];
  
      const uploadImage = async (file: File, field: string) => {
        const formData = new FormData();
        formData.append("files", file);
        formData.append("ref", "api::project.project");
        formData.append("refId", appId);
        formData.append("field", field);
  
        const uploadResponse = await fetch("https://project.zas.media/api/upload", {
          method: "POST",
          headers: {
            Authorization: `Bearer a6ee1bd7ccbfef1a8db07e17301f655d97fb2e6afef919ee948255bda46e119f6047f21dae468735686d475f34a57749accdaf90bc15adca708605fa98957b23a65c62db8570d6bcf36cc67355c35b7d1abafefa286b49cf899f7c30b93a27808742aea88aa3f701f3e8ced623b28924849d5206a9a3b20331f5906e8ed68638`, // Substitua pelo seu token real
          },
          body: formData,
        });
  
        if (!uploadResponse.ok) {
          throw new Error(`❌ Erro ao enviar a imagem ${field}`);
        }
  
        const uploadResult = await uploadResponse.json();
        console.log(`✅ Imagem de ${field} enviada com sucesso:`, uploadResult);
  
        return { field, id: uploadResult[0].id };
      };
  
      const checkAndUpload = (image: string | File | null, field: string) => {
        if (image) {
          const file =
            typeof image === "string" && image.startsWith("data:image")
              ? dataURLtoFile(image, `${field}.png`)
              : (image as File);
  
          uploadPromises.push(uploadImage(file, field));
        }
      };
  
      checkAndUpload(appData.icon!, "icon");
      checkAndUpload(appData.logo!, "logo");
      checkAndUpload(appData.appBarLogo!, "logo_appbar");
      checkAndUpload(appData.radioLogo!, "logo_radio");
  
      const uploadedImages = await Promise.all(uploadPromises);
  
      const updateData = uploadedImages.reduce((acc, img) => {
        acc[img.field] = img.id;
        return acc;
      }, {} as Record<string, number>);
  
      console.log("🔄 Atualizando projeto com as imagens:", updateData);
  
      const updateResponse = await fetch(`https://project.zas.media/api/projects/${projectId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer a6ee1bd7ccbfef1a8db07e17301f655d97fb2e6afef919ee948255bda46e119f6047f21dae468735686d475f34a57749accdaf90bc15adca708605fa98957b23a65c62db8570d6bcf36cc67355c35b7d1abafefa286b49cf899f7c30b93a27808742aea88aa3f701f3e8ced623b28924849d5206a9a3b20331f5906e8ed68638`, // Substitua pelo seu token real
        },
        body: JSON.stringify({ data: updateData }),
      });
  
      if (!updateResponse.ok) {
        let errorDetail = '';
        try {
          const errorJson = await updateResponse.json();
          errorDetail = JSON.stringify(errorJson, null, 2);
        } catch {
          errorDetail = await updateResponse.text();
        }
      
        console.error("❌ Erro ao atualizar o projeto com as imagens:", errorDetail);
        throw new Error(`Erro do servidor: ${errorDetail}`);
      }
  
      console.log("✅ Projeto atualizado com sucesso!");
    } catch (error) {
      console.error("Erro no upload:", error);
      setError((error as Error).message);
    }
  };

  return (
    <div className="content" style={{ minHeight: 'auto' }}>
      <div className="mx-auto max-w-2xl lg:text-center">
        <p className="color-primary mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl lg:text-balance">Tudo pronto! 🚀</p>
        <p className="mt-6 font-semibold tracking-tight text-pretty text-gray-900 sm:text-2xl lg:text-balance">Você chegou à última etapa do processo de personalização do seu app. </p>
        <p className="mt-10 text-lg/8 text-gray-600">Antes de finalizar, revise com atenção todas as informações que você inseriu nas etapas anteriores, como o nome do app, cores, logotipo e layout.</p>
        <p className="mt-2 text-lg/8 text-gray-600">Caso queira fazer alguma alteração, volte às etapas anteriores e ajuste os detalhes.</p>
        <p className="mt-2 text-lg/8 text-gray-600">Quando estiver satisfeito com a personalização, clique no botão abaixo para concluir o processo. vDepois de finalizar, suas informações serão enviadas para a configuração do app.</p>
      </div>
      <div className="flex justify-between mt-10">
        <Link
          to={`/${appData.id}/mais`}
          className="bg-primary text-white px-6 py-3 text-xl rounded-md flex items-center space-x-2"
        >
          <i className="fas fa-arrow-left"></i>
          <span>Navegação Mais</span>
        </Link>
        <button
          onClick={handleFinish}
          disabled={loading}
          className={`px-6 py-3 text-xl rounded-md flex items-center space-x-2 ${
            loading ? 'bg-gray-400' : 'bg-primary text-white'
          }`}
        >
          {loading ? (
            <>
              <span>Enviando...</span>
              <i className="fas fa-spinner animate-spin"></i>
            </>
          ) : (
            <>
              <span>Finalizar</span>
              <i className="fas fa-check"></i>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default Finish;
